import getQueryParamsFromStringObjectUtil from 'utils/object/get-query-params-from-string'
import { GIFT_QUERY_PARAMETER } from 'modules/gift/constants'

export default function shouldFlattenSamplesUrlLocationUtil () {
  return getQueryParamsFromStringObjectUtil()[GIFT_QUERY_PARAMETER.FLATTEN_SAMPLES] === 'true'
}
